import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { EffectiveCompanySubscriptionDto } from '~/swagger/subscriptions/Api';

const SUBSCRIPTIONS_BASE_URL = `${envConfig.service.subscriptions}/company-portal`;

export class SubscriptionsRepository extends BaseRestRepository {
  public async getEffectiveSubscription(): Promise<EffectiveCompanySubscriptionDto> {
    const url = `${SUBSCRIPTIONS_BASE_URL}/subscriptions/effective`;
    const response = await this.fetchWithAuth(url, {}, false);
    return this.getJsonResponse(response);
  }
}
